import Vue from 'vue'
import Router from 'vue-router'

import customizeInd from '@customizeProMixins/getCustomizeInd'
import CustomRouter from './customize/index'

const originalReplace = Router.prototype.replace

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err)
}

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

const routerMode = process.env.NODE_ENV === 'production' ? 'history' : 'hash'
// 开发时用history模式可能会出现访问带hashMap的app.xxxxxx.js文件，文件名找不到，导致程序报错，因此开发用hash模式；打包用history模式

const router = new Router({
  mode: routerMode,
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPostion) {
    return { x: 0, y: 0 }
  },
  routes: CustomRouter,
})

// 全局导航钩子
router.beforeEach((to, from, next) => {
  console.debug('beforeEach 2:', to, window.document.title)
  let webtTitle = '超赛平台'
  if (customizeInd === 0) {
    webtTitle = '超赛平台'
  } else if (customizeInd === 1) {
    webtTitle = 'CMG'
  }
  // if (to.query.title) { // 路由发生变化修改页面title
  //   document.title = to.query.title
  // }
  // console.debug('store:', store);
  // if (to.meta.requireLogin) {

  // } else {
  //   next()
  // }

  if (to.meta.title) {
    webtTitle = `${webtTitle}-${to.meta.title}`
  }
  window.document.title = webtTitle
  next()
})

export default router
